import { Navigate, Route, Routes } from 'react-router-dom';

// layout
import CommonLayout from 'components/layout/CommonLayout';
import LoginLayout from 'components/layout/LoginLayout';

// pages
import Channel from './creator/detail/Creator';
import Search from './creator/Index';
import Login from './login/Login';
import PasswordHelp from './login/PasswordHelp';
import Recommend from './recommend/Index';

const PageRouter = () => {
	return (
		<>
			<Routes>
				<Route element={<CommonLayout />}>
					<Route path="recommend" element={<Recommend />} />
					<Route path="creator" element={<Search />} />
					<Route
						path="creator/report/:platform/:recommendationId/:creatorPk"
						element={<Channel />}
					/>
					<Route path="*" element={<Navigate to="/recommend" replace />} />
				</Route>
				<Route path="login" element={<LoginLayout />}>
					<Route path="password_help" element={<PasswordHelp />} />
					<Route index element={<Login />} />
				</Route>
			</Routes>
		</>
	);
};

export default PageRouter;
